export default __webpack_public_path__ + "static/media/show-earphone-2.0d9ce498.webp";